import { render, staticRenderFns } from "./modifygroup.vue?vue&type=template&id=1bdb3ac2&scoped=true&"
import script from "./modifygroup.vue?vue&type=script&lang=js&"
export * from "./modifygroup.vue?vue&type=script&lang=js&"
import style0 from "./modifygroup.vue?vue&type=style&index=0&id=1bdb3ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdb3ac2",
  null
  
)

export default component.exports